import React, { Component } from 'react';
import axios from 'axios';
import styled from '@emotion/styled';
import { FormattedMessage, injectIntl } from 'react-intl';

import ModalActionCreator from 'action_creators/modal';

import './index.scss';

class ContactModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      message: '',
      newGuestEmail: '',
      submitLoading: false,
      submitSuccess: false,
    };
  }

  updateMessage = (e) => {
    this.setState({ message: e.target.value });
  };

  updateNewGuestEmail = (e) => {
    this.setState({ newGuestEmail: e.target.value });
  };

  formValid = () => {
    const { newGuestEmail, message } = this.state;
    const { guestEmail } = this.props;

    let emailValid = false;
    const emailRegex = /\S+@\S+\.\S+/;
    if (newGuestEmail && newGuestEmail.length >= 5) {
      emailValid = emailRegex.test(newGuestEmail);
    } else {
      emailValid = guestEmail && guestEmail.length >= 5;
    }

    if (message.length >= 1 && emailValid) return true;

    return false;
  };

  submitClicked = () => {
    if (!this.state.message.length) return;
    this.setState({ submitLoading: true });

    const { originLocation, bookingId, guestId } = this.props;
    const { newGuestEmail } = this.state;

    const params = {
      origin_location: originLocation,
      message: this.state.message,
      guest_id: guestId,
      booking_id: bookingId,
      new_guest_email:
        newGuestEmail && newGuestEmail.length >= 5 ? newGuestEmail : null,
    };

    axios
      .post('/api/users/:user_id/message', params, {
        headers: {
          'X-CSRF-Token': this.props.authenticityToken,
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
      .then((_response) => {
        this.setState({ submitLoading: false, submitSuccess: true });
      })
      .catch((_error) => {
        this.setState({ submitLoading: false, submitSuccess: false });
      });
  };

  submitSuccessClicked = () => {
    const { newGuestEmail } = this.state;
    if (newGuestEmail && newGuestEmail.length >= 5) {
      window.location.reload();
    } else {
      ModalActionCreator.hide();
      this.setState({ message: '', newGuestEmail: '', submitLoading: false });

      // To time with modal fade out transition
      setTimeout(() => {
        this.setState({
          submitSuccess: false,
        });
      }, 500);
    }
  };

  renderMobileHeader = () => {
    return (
      <div className="mobileHeader">
        <div className="leftAction" onClick={() => ModalActionCreator.hide()}>
          <i className="fa fa-arrow-left" aria-hidden="true" />
        </div>
        <div className="title">
          <FormattedMessage id="CONTACT_US" defaultMessage="Contact us" />
        </div>
        <div className="rightAction" />
      </div>
    );
  };

  renderGuestEmail = () => {
    const { guestEmail } = this.props;
    let content = '';

    if (guestEmail && guestEmail.length >= 5) {
      content = (
        <div>
          <FormattedMessage id="FROM" defaultMessage="From" />{' '}
          <span className="email">{guestEmail}</span>
        </div>
      );
    } else {
      content = (
        <div className="field">
          <label htmlFor="email">
            {this.props.intl.formatMessage({ defaultMessage: 'Email Address' })}
            :
          </label>
          <input
            id="email"
            type="email"
            placeholder="email@example.com"
            onChange={this.updateNewGuestEmail}
          />
        </div>
      );
    }

    return <div className="guestEmail">{content}</div>;
  };

  render() {
    const { message, submitLoading, submitSuccess, newGuestEmail } = this.state;
    const { businessName, guestEmail } = this.props;

    const SendMessage = styled('button')`
      background-color: ${(props) => props.buttonColor} !important;

      &.disable {
        background-color: ${(props) => props.buttonColor} !important;
        color: white !important;
        opacity: 0.3;
      }
    `;

    let displayEmail = '';
    if (guestEmail && guestEmail.length >= 5) displayEmail = guestEmail;
    else if (newGuestEmail && newGuestEmail.length >= 5)
      displayEmail = newGuestEmail;

    if (submitSuccess) {
      return (
        <div className="contactModal submitSuccess">
          {this.renderMobileHeader()}
          <div className="header" data-testid="contact-message-success">
            <div className="heading">
              {this.props.intl
                .formatMessage({ defaultMessage: 'Message sent' })
                .toUpperCase()}
            </div>
          </div>
          <div className="successMessage">
            <FormattedMessage
              defaultMessage="You will hear from {name} shortly."
              values={{ name: businessName }}
            />
            <br />
            <br />
            <FormattedMessage
              defaultMessage="The responses will go to your email {email}."
              values={{
                email: <span className="email">{displayEmail}</span>,
              }}
            />
          </div>
          <div className="modalActions">
            <SendMessage
              className="submitButton ui fluid huge button brand-bg"
              onClick={this.submitSuccessClicked}
              buttonColor={this.props.buttonColor}
              data-testid="hide-message-success-modal"
            >
              <FormattedMessage id="OKAY" defaultMessage="Okay" />
            </SendMessage>
          </div>
        </div>
      );
    }

    return (
      <div className="contactModal">
        {this.renderMobileHeader()}
        <div className="header">
          <h1 className="heading">
            {' '}
            <FormattedMessage
              id="SEND_A_MESSAGE_TO"
              defaultMessage="Send a message to"
            />
          </h1>
          <div className="businessNAme">{businessName}</div>
        </div>
        <div className="inputField">
          <textarea
            value={message}
            onChange={this.updateMessage}
            placeholder={`${this.props.intl.formatMessage({ defaultMessage: 'Enter your message here' })}...`}
            data-testid="contact-modal-text-area"
          />
        </div>
        {this.renderGuestEmail()}
        <div className="modalActions">
          <SendMessage
            data-testid="submit-btn-contact-modal"
            className={`submitButton ui fluid huge button brand-bg ${
              submitLoading ? 'loading' : null
            } ${this.formValid() ? null : 'disable'}`}
            onClick={this.submitClicked}
            buttonColor={this.props.buttonColor}
          >
            <FormattedMessage id="SEND_MESSAGE" defaultMessage="Send message" />
          </SendMessage>
        </div>
      </div>
    );
  }
}

export default injectIntl(ContactModal);
